import * as types from "./actionType";

const initialState = {
  fetchingPartnersList: false,
  partnersList: [],
  partnersListCount: 0,
  partnersPendingCount: 0,
  stateStatus: false,
  states: [],
  cityStatus: false,
  cities: [],
  partnerDetailsStatus: false,
  partnerDetailsData: null,
  partnerDataStatus: false,
  partnerData: [],
  pieChartStatistics: null,
  updatedDetails: null,
  fetchingUpdatedDetails: false,
  fetchingPieChartStatistics: false,
  partnerRankingNumber: [],
};

function partnersReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_PARTNERS_LIST:
      return {
        ...state,
        fetchingPartnersList: true,
      };

    case types.FETCH_PARTNERS_LIST_SUCCESS:
      return {
        ...state,
        fetchingPartnersList: false,
        partnersList: action.payload,
        partnersListCount: action.count,
        partnersPendingCount: action.pendingCount,
      };

    case types.FETCH_PARTNERS_LIST_FAILED:
      return {
        ...state,
        fetchingPartnersList: false,
        partnersList: [],
      };
    case types.FETCH_STATE:
      return {
        ...state,
        stateStatus: true,
        states: [],
      };
    case types.FETCH_STATE_SUCCESS: {
      return {
        ...state,
        stateStatus: false,
        states: action.payload,
      };
    }
    case types.FETCH_STATE_FAILED: {
      return {
        ...state,
        stateStatus: false,
        states: [],
      };
    }

    case types.FETCH_CITY:
      return {
        ...state,
        cityStatus: true,
        cities: [],
      };
    case types.FETCH_CITY_SUCCESS: {
      return {
        ...state,
        cityStatus: false,
        cities: action.payload,
      };
    }
    case types.FETCH_CITY_FAILED: {
      return {
        ...state,
        cityStatus: false,
        cities: [],
      };
    }
    case types.FETCH_PARTNERS_DETAILS: {
      return {
        ...state,
        partnerDetailsStatus: true,
        partnerDetailsData: null,
      };
    }
    case types.FETCH_PARTNERS_DETAILS_SUCCESS: {
      return {
        ...state,
        partnerDetailsStatus: false,
        partnerDetailsData: action.payload,
      };
    }
    case types.FETCH_PARTNERS_DETAILS_FAILED: {
      return {
        ...state,
        partnerDetailsStatus: false,
        partnerDetailsData: null,
      };
    }
    case types.FETCH_PARTNERS_DETAILS_POST: {
      return {
        ...state,
        partnerDataStatus: true,
        partnerData: null,
      };
    }
    case types.FETCH_PARTNERS_DETAILS_POST_SUCCESS: {
      return {
        ...state,
        partnerDataStatus: false,
        partnerData: action.payload,
      };
    }
    case types.FETCH_PARTNERS_DETAILS_POST_FAILED: {
      return {
        ...state,
        partnerDataStatus: false,
        partnerData: null,
      };
    }
    case types.PIE_CHART_STATISTICS:
      return {
        ...state,
        pieChartStatistics: null,
        fetchingPieChartStatistics: false,
      };
    case types.PIE_CHART_STATISTICS_SUCCESS:
      return {
        ...state,
        pieChartStatistics: action.payload,
        fetchingPieChartStatistics: true,
      };
    case types.PIE_CHART_STATISTICS_FAILED:
      return {
        ...state,
        pieChartStatistics: null,
        fetchingPieChartStatistics: false,
      };

    case types.PARTNER_RANKING:
      return {
        ...state,
        partnerRankingNumber: [],
      };
    case types.PARTNER_RANKING_SUCCESS:
      return {
        ...state,
        partnerRankingNumber: action.payload,
      };
    case types.PARTNER_RANKING_FAILED:
      return {
        ...state,
        partnerRankingNumber: [],
      };

    case types.PARTNER_UPDATE_DETAILS:
      return {
        ...state,
        fetchingUpdatedDetails: true,
      };
    case types.PARTNER_UPDATE_DETAILS_SUCCESS:
      return {
        ...state,
        fetchingUpdatedDetails: false,
        updatedDetails: action.payload,
      };
    case types.PARTNER_UPDATE_DETAILS_FAILED:
      return {
        ...state,
        fetchingUpdatedDetails: false,
        updatedDetails: null,
      };
    case types.CLEAR_PREVIOUS_REDUCERS:
      return {
        partnersList: [],
        fetchingPartnersList: false,
        stateStatus: false,
        cityStatus: false,
      };

    default:
      return state;
  }
}

export default partnersReducer;
